import React, {useCallback} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {labels} from '../../../../../../util/utils';
import Utility from '../../../../../../util/utilityfunctions';
import Modal from '../../../../Modal/Modal';

export const BodySpecialDeleteItemModal = (props) => {
	const {title, name, show, setIsLoading, onDelete, onHide, confirmationText, confirmButtonLabel} = props;

	const handleOnDelete = useCallback(() => {
		setIsLoading(true);
		onHide();
		onDelete();
	}, []);

	return (
		<StyledBodySpecialDeleteItemModal
			show={show}
			onHide={onHide}
			onOkClick={handleOnDelete}
			title={title}
			showButtons
			confirmBtnTitle={confirmButtonLabel}
			closeBtnTitle={labels.cancelLabel}
			closeTitle={labels.cancelLabel}
			modalsize="x-small"
			modalbodystyle="body-special-delete-item-modal-body"
		>
			{Utility.createRichTextElement(confirmationText.replace('{0}', name), 'BodyMessage')}
		</StyledBodySpecialDeleteItemModal>
	);
};

BodySpecialDeleteItemModal.propTypes = {
	title: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	show: PropTypes.bool,
	setIsLoading: PropTypes.func.isRequired,
	onDelete: PropTypes.func.isRequired,
	onHide: PropTypes.func,
	confirmationText: PropTypes.string,
	confirmButtonLabel: PropTypes.string
};

BodySpecialDeleteItemModal.defaultProps = {
	show: false,
	confirmationText: labels.deleteEntityConfirmation,
	confirmButtonLabel: labels.delete
};

export default BodySpecialDeleteItemModal;

const StyledBodySpecialDeleteItemModal = styled(Modal)`
	width: var(--px-720) !important;
	.body-special-delete-item-modal-body {
		.BodyMessage {
			padding: var(--px-20) 0;
		}
	}
	&.message {
		.body-special-delete-item-modal-body {
			min-height: var(--px-100) !important;
		}
	}
	.modalbodystyle {
		min-height: var(--px-160) !important;
	}
`;
